import { getMessageCount, getMessages, ReadMessage } from "@/api/openapi";
import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import { translate } from "@/config/translator";
import { KeyLabelPair, TableColumn } from "@/config/types";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const LIMIT = 30;

export function useMessages() {
  const { lang } = useContext(PspContext);
  const navigate = useNavigate();
  const isTablet = useIsTablet();

  const [messages, setMessages] = useState<ReadMessage[]>();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState<number>();
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getMessages({
      query: { limit: LIMIT, offset: LIMIT * page, query_string: searchQuery },
    }).then(({ data, error }) => {
      if (error) {
        toast(translate("couldntLoadMessages", lang));
      } else {
        setMessages(data);
      }
    });

    getMessageCount().then(({ data, error }) => {
      if (error) {
        toast(translate("couldntLoadMessageCount", lang));
      } else {
        setTotalPages(Math.ceil(data / LIMIT) || 1);
      }
    });
  }, [lang, page, searchQuery]);

  const columns: TableColumn[] = [
    { key: "name", label: translate("title", lang), className: "w-1/2" },
    {
      key: "date",
      label: translate("date", lang),
      className: "min-w-24 w-1/6",
    },
    {
      key: "sender",
      label: translate("sender", lang),
      className: "min-w-44 w-1/6",
    },
    {
      key: "status",
      label: translate("status", lang),
      className: "min-w-28 w-1/6",
    },
    { key: "action", label: translate("action", lang), className: "w-16" },
  ];

  return {
    columns,
    messages,
    setPage,
    navigate,
    isTablet,
    totalPages,
    page,
    lang,
    searchQuery,
    setSearchQuery,
  };
}
